// extracted by mini-css-extract-plugin
export var badge = "styles-module__badge___EzPJ5";
export var badgeInfo = "styles-module__badgeInfo___JhFaD";
export var badgeWarning = "styles-module__badgeWarning___KOP7Y";
export var badgeDanger = "styles-module__badgeDanger___jJ3tp";
export var icon = "styles-module__icon___Ls_Hn";
export var text = "styles-module__text___jkx3J";